import { render } from "./Data.vue?vue&type=template&id=88f20218&ts=true"
import script from "./Data.vue?vue&type=script&lang=ts"
export * from "./Data.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__